import React from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@mui/material/styles';

// Soft Aurora background (https://reactbits.dev/backgrounds/soft-aurora):
// a few large, heavily-blurred pastel gradient blobs that drift slowly. Subtle
// and theme-matching; sits behind content (pointer-events: none, z-index 0).
const drift1 = keyframes`
  0%   { transform: translate(0, 0) scale(1); }
  100% { transform: translate(6%, 8%) scale(1.15); }
`;
const drift2 = keyframes`
  0%   { transform: translate(0, 0) scale(1.1); }
  100% { transform: translate(-8%, -6%) scale(1); }
`;
const drift3 = keyframes`
  0%   { transform: translate(0, 0) scale(1); }
  100% { transform: translate(5%, -7%) scale(1.2); }
`;

const blob = (extra) => ({
  position: 'absolute',
  borderRadius: '50%',
  filter: 'blur(90px)',
  ...extra,
});

export default function SoftAurora({
  // Bluish scheme: sky blue, azure, cyan and periwinkle.
  colors = ['#a3c8f5', '#86b4f2', '#a6def2', '#b7c2f7'],
  opacity = 0.72,
  // `fixed` anchors the blobs to the viewport so they stay visible (and keep
  // drifting) as a long page scrolls — used when the aurora is the global page
  // background. Default `absolute` fills the nearest positioned container.
  fixed = false,
}) {
  return (
    <Box
      aria-hidden
      sx={{
        position: fixed ? 'fixed' : 'absolute',
        inset: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
        zIndex: 0,
        opacity,
      }}
    >
      <Box sx={blob({ width: '46vw', height: '46vw', top: '-14%', left: '-8%', background: `radial-gradient(circle, ${colors[0]}, transparent 74%)`, animation: `${drift1} 20s ease-in-out infinite alternate` })} />
      <Box sx={blob({ width: '42vw', height: '42vw', top: '-8%', right: '-6%', background: `radial-gradient(circle, ${colors[1]}, transparent 74%)`, animation: `${drift2} 26s ease-in-out infinite alternate` })} />
      <Box sx={blob({ width: '40vw', height: '40vw', bottom: '-18%', left: '16%', background: `radial-gradient(circle, ${colors[2]}, transparent 74%)`, animation: `${drift3} 23s ease-in-out infinite alternate` })} />
      <Box sx={blob({ width: '34vw', height: '34vw', bottom: '-12%', right: '6%', background: `radial-gradient(circle, ${colors[3]}, transparent 74%)`, animation: `${drift1} 29s ease-in-out infinite alternate` })} />
    </Box>
  );
}
